export default function SectionHeader({
    overline,
    title,
    description,
    align = "left",
    className = "",
    testId = "section-header",
}) {
    const a = align === "center" ? "text-center mx-auto" : "text-left";
    return (
        <div className={`max-w-3xl ${a} ${className}`} data-testid={testId}>
            {overline && <p className="overline mb-4">{overline}</p>}
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-extrabold leading-[1.05] text-tca-ink">
                {title}
            </h2>
            {description && (
                <p className="mt-5 text-base sm:text-lg text-tca-mute leading-relaxed">{description}</p>
            )}
        </div>
    );
}
